<template>
  <div></div>
</template>

<script>
import { getAppletJumpShortChainDynamically, getJumpShortChain, getJumpShortChainTech } from '@/api/linkToMiniApp';
import { parseQueryString } from '@/utils/util';
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {
    this.init();
  },
  mounted() {},
  watch: {},
  methods: {
    init() {
      const { client = 'emall-wechat', pageType, param, imgFlag = '' } = this.$route.query;
      if (client == 'emall-wechat') {
        if (pageType) {
          // pageType：1狼道注册页、2收银台
          const params = parseQueryString(window.location.href);
          getJumpShortChain(params).then((res) => {
            if (res && res.data) {
              window.location.href = res.data;
            }
          });
        } else {
          getAppletJumpShortChainDynamically({ param: imgFlag ? param + '-1' : param }).then((res) => {
            if (res && res.data) {
              window.location.href = res.data;
            }
          });
        }
      } else if (client == 'tech-wechat') {
        if (pageType == 1) {
          // 售后编辑页
          const params = parseQueryString(window.location.href);
          getJumpShortChainTech(params).then((res) => {
            if (res && res.data) {
              window.location.href = res.data;
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
